/**
 * 运营中心相关数据
 */
const type = "OPERATE_";

//二级缓存
function set(name, val) {
    if (val === "" || val === null) {
        sessionStorage.removeItem(type + name);
        return
    }
    if (typeof val === "object") {
        sessionStorage.setItem(type + name, JSON.stringify(val));
    } else {
        sessionStorage.setItem(type + name, val);
    }
}

function get(name) {
    const data = sessionStorage.getItem(type + name);
    if (data === null) {
        return ""
    }
    try {
        return JSON.parse(data);
    } catch (e) {
        return data
    }
}

export default {
    namespaced: true,
    state: {
        courseInfo: null, // 课程信息
    },
    getters: {
        getCourseInfo: state => () => {
            if (!state.courseInfo) {
                state.courseInfo = get("COURSE_INFO");
            }
            return state.courseInfo
        },
    },
    mutations: {
        setCourseInfo(state, data) {
            state.courseInfo = data;
            set("COURSE_INFO", data);
        },

    },
}
